<template>
  <div class="container-fluid route-view-card d-flex flex-column fill-height">
    <v-stepper v-model="step" non-linear alt-labels class="fill-height stepper-bg">
      <!--  CABEÇALHO  -->
      <v-stepper-header class="align-center px-4 elevation-1 white">

        <!--  CANCELAR  -->
        <v-btn color="#35565B" outlined class="mr-14" @click="$router.back()">
          {{ boletimSanitario.idBoletimSanitario > 0 ? 'Voltar' : 'Cancelar' }}
        </v-btn>

        <v-stepper-step color="#00A5A2" :complete="Boolean(boletimSanitario.idBoletimSanitario)"
                        :editable="podeAlterar" edit-icon="$complete" :step="1">
          Informação
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="#00A5A2" :complete="this.boletimSanitario.cdStatusBoletimSanitario > 0"
                        :editable="this.boletimSanitario.cdStatusBoletimSanitario > 0 && podeAlterar"
                        edit-icon="$complete" :step="2" :loading="loading">
          Medicação
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="#00A5A2" :complete="this.boletimSanitario.cdStatusBoletimSanitario > 1"
                        :editable="this.boletimSanitario.cdStatusBoletimSanitario > 1 && podeAlterar"
                        edit-icon="$complete" :step="3">
          Sintomas
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="#00A5A2" :complete="this.boletimSanitario.cdStatusBoletimSanitario > 2"
                        :editable="this.boletimSanitario.cdStatusBoletimSanitario > 2 && podeAlterar"
                        edit-icon="$complete" :step="4">
          Destino
        </v-stepper-step>
        <v-stepper-step color="#00A5A2" :complete="boletimSanitario.idBoletimSanitario > 0" :editable="boletimSanitario.idBoletimSanitario > 0"
                        edit-icon="mdi-eye-outline" :step="5">
          Resumo
        </v-stepper-step>

        <!--  CONTINUAR  -->
        <v-btn v-if="step === 5" color="#00C1B6" class="ml-14 white--text" @click="proximaEtapa()" :loading="loading"
               :outlined="!podeEmitir"
               :disabled="!podeEmitir">
          {{ 'Emitir' }}
        </v-btn>
        <v-btn v-else color="#00C1B6" class="ml-14 white--text" @click="proximaEtapa()" :loading="loading"
               :outlined="!podeAlterar"
               :disabled="!podeAlterar || !btnContinuar || loading">
          {{ 'Continuar' }}
        </v-btn>

      </v-stepper-header>

      <!--  TELA PRINCIPAL  -->
      <v-stepper-items>
        <v-stepper-content class="ma-0 pa-0" :step="1">
          <dados-boletim-sanitario :boletimSanitario="boletimSanitario" :btnContinuar.sync="btnContinuar"
                       :key="`view__${boletimSanitario.idBoletimSanitario}__informacoes`" v-if="!loading"
                       :step="step" />
          <loading-state v-else />
        </v-stepper-content>
        <v-stepper-content class="ma-0 pa-0" :step="2">
          <medicacao-boletim-sanitario :boletimSanitario="boletimSanitario" :btnContinuar.sync="btnContinuar"
                       :key="`view__${boletimSanitario.idBoletimSanitario}__medicacao`" v-if="!loading"
                       :step="step" />
          <loading-state v-else />
        </v-stepper-content>
        <v-stepper-content class="ma-0 pa-0" :step="3">
          <sinal-clinico-boletim-sanitario :boletimSanitario="boletimSanitario" :btnContinuar.sync="btnContinuar"
                       :key="`view__${boletimSanitario.idBoletimSanitario}__sintomas`" v-if="!loading" />
          <loading-state v-else />
        </v-stepper-content>
        <v-stepper-content class="ma-0 pa-0" :step="4">
          <mercado-destino-boletim-sanitario :boletimSanitario="boletimSanitario" :btnContinuar.sync="btnContinuar"
                       :key="`view__${boletimSanitario.idBoletimSanitario}__destino`" v-if="!loading"
                       :step="step" />
          <loading-state v-else />
        </v-stepper-content>
        <v-stepper-content class="ma-0 pa-0" :step="5">
          <resumo-boletim-sanitario :idBoletimSanitario="boletimSanitario.idBoletimSanitario" :btnContinuar.sync="btnContinuar" :step="step"
                       :key="`view__${boletimSanitario.idBoletimSanitario}__resumo`" v-if="!loading" />
          <loading-state v-else />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

  </div>
</template>

<script>
import {MODELS} from "../resources";
import Vue from "vue";
import DadosBoletimSanitario from "../components/DadosBoletimSanitario";
import MedicacaoBoletimSanitario from "../components/MedicacaoBoletimSanitario";
import SinalClinicoBoletimSanitario from "../components/SinalClinicoBoletimSanitario";
import MercadoDestinoBoletimSanitario from "../components/MercadoDestinoBoletimSanitario";
import ResumoBoletimSanitario from "../components/ResumoBoletimSanitario";
import LoadingState from "../components/LoadingState";
import { dateLocalToIso, dateIsoToLocal } from '@/filters/utils'

export default {
  name: "BoletimSanitario",
  components: {
    LoadingState,
    ResumoBoletimSanitario,
    MercadoDestinoBoletimSanitario,
    SinalClinicoBoletimSanitario, MedicacaoBoletimSanitario, DadosBoletimSanitario},
  data: () => ({
    step: 0,
    boletimSanitario: new MODELS.BOLETIM_SANITARIO({}),
    loading: true,
    btnContinuar: false,
  }),
  computed: {
    cdEmpresa() {
      return this.$keycloak['tokenParsed']["PARTNERID"]
    },
    podeAlterar() {
      return this.boletimSanitario.cdStatusBoletimSanitario !== 5
    },
    podeEmitir() {
      return this.step === 5 && this.boletimSanitario.cdStatusBoletimSanitario === 4
    }
  },
  methods: {
    dateLocalToIso,
    dateIsoToLocal,
    gerarBoletimSanitarioPDF() {
      this.gerandoPDF = true
      const idBoletimSanitario = this.boletimSanitario.idBoletimSanitario
      this.$axios.get(`boletim-sanitario/${idBoletimSanitario}/boletim-sanitario-digital-pdf/`, {
        responseType: "blob"
      }).then((res) => {
        if (res.data.size === 0) {
          this.$store.commit("setSnack", {type: "error", msg: 'Erro ao gerar PDF'})
          return
        }
        let blob = new Blob([res.data], {type: 'application/octet-stream'})
        let a = document.createElement('a');
        a.href = URL.createObjectURL(blob)
        a.download = `boletim_sanitario_${this.boletimSanitario.idBoletimSanitario}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(error => {
        this.$store.commit("setSnack", {type: "error", msg: error})
      })
      .finally(() => this.gerandoPDF = false)
    },
    proximaEtapa() {
      if (this.step === 1 && !this.boletimSanitario.idBoletimSanitario) this.criarBoletimSanitario()
      else if (this.step !== 5) this.atualizarBoletimSanitario()
      else this.gerarBoletimSanitarioPDF()
      if (this.step !== 5) this.step++
    },
    criarBoletimSanitario() {
      this.loading = true
      this.boletimSanitario.lstSaidasAnimais = _.fromPairs(
          this.boletimSanitario.saidaAnimais.map(saida => [saida.cdSaidaAnimais, saida.nrCarga])
      )

      this.$axios.post('boletim-sanitario/', this.boletimSanitario)
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) return

            const response = res.data[0].data

            this.$router.replace('/boletimSanitario/' + response.idBoletimSanitario)
            this.loadBoletimSanitario()
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
    },
    atualizarBoletimSanitario() {
      this.loading = true
      const cdStatusBoletim = this.step
      this.boletimSanitario.lstSaidasAnimais = _.fromPairs(
          this.boletimSanitario.saidaAnimais.map(saida => [saida.cdSaidaAnimais, saida.nrCarga])
      )
      this.boletimSanitario.lstCdMercadosDestinos = this.boletimSanitario.mercadosDestino.map(md => md.cdMercadoDestino)

      //TODO necessário porém deveria ser manejado pela API, se não enviar cdStatusBoletimSanitario dá 400
      this.boletimSanitario.cdStatusBoletimSanitario = cdStatusBoletim
      //

      this.$axios.put('boletim-sanitario/' + this.boletimSanitario.idBoletimSanitario, this.boletimSanitario)
          .then(res => {
            this.atualizarStatusBoletimSanitario(cdStatusBoletim)
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
    },
    atualizarStatusBoletimSanitario(cdStatusBoletim) {
      this.loading = true
      const status = {
        cdBoletimSanitario: this.boletimSanitario.idBoletimSanitario,
        cdStatusBoletimSanitario: cdStatusBoletim
      }

      this.$axios.post('boletim-sanitario-status/', status)
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) return

            const cdStatus = res.data[0].data.cdStatusBoletimSanitario
            this.boletimSanitario.cdStatusBoletimSanitario = cdStatus
            this.boletimSanitario.dtEmissao = this.dateLocalToIso(this.boletimSanitario.dtEmissao)
            this.boletimSanitario.dtRetiradaRacao = this.dateLocalToIso(this.boletimSanitario.dtRetiradaRacao)
            if (cdStatus !== 5) this.loadBoletimSanitario()
            else this.$router.replace({name: 'pesquisaBoletimSanitario'})
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
    },
    loadBoletimSanitario() {
      this.loading = true
      this.$axios.get(`boletim-sanitario/${this.$route.params.idBoletimSanitario}`)
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) return

            const boletim = res.data[0].data
            boletim.dtEmissao = this.dateIsoToLocal(boletim.dtEmissao)
            boletim.dtRetiradaRacao = this.dateIsoToLocal(boletim.dtRetiradaRacao)
            if (boletim.cdStatusBoletimSanitario === 5) {
              this.step = 5
              this.btnContinuar = false
            }

            this.boletimSanitario = boletim
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.step = 1
          })
          .finally(() => {
            this.loading = false
          })
    },
  },
  created() {
    if (this.cdEmpresa == 4) {
      this.$store.commit("setSnack", {type: "error", msg: "Você não possui acesso a essa funcionalidade!"})
    }
    else {
      this.boletimSanitario.cdLoteProducao = this.$route.query.lp

      if (!this.$route.params.idBoletimSanitario || this.$route.params.idBoletimSanitario < 1)
        this.loading = false
      else
        this.loadBoletimSanitario()

      this.step = 1
    }
  }
}
</script>

<style lang="scss">
.route-view-card {
  background-color: #F2F5F3;
}
.stepper-bg {
  background-color: #F2F5F3 !important;
}

.stick-bar {
  position: sticky !important;
  top: 48px !important;
  left: 0 !important;
  z-index: 4;
}

.v-stepper__wrapper {
  height: 100%;
}

//TRANSITION
.page-transition-leave-active {
  position: absolute;
}

.page-transition-enter-active, .page-transition-leave, .page-transition-leave-to {
  transition: 0.8ms;
}

.page-transition-enter, .page-transition-leave-to {
  opacity: 0;
}
</style>
